/**
 * AboutYouFooter.js
 *
 * Renders the footer for the "About You" onboarding step, including links to terms and policies.
 */
import React from 'react';

/**
 * Footer component for the "About You" step.
 *
 * @returns {JSX.Element} The rendered footer.
 */
export default function AboutYouFooter() {
  return (
    <div className="text-sm text-cs-gray-500 mr-auto">
      <span>*By joining CommunityShare you agree to our </span>
      <a className="underline text-cs-orange-500" target="_blank" rel="noreferrer" href="https://www.communityshare.org/terms-of-use/">Terms of Use</a>
      <span> and </span>
      <a className="underline text-cs-orange-500" target="_blank" rel="noreferrer" href="https://www.communityshare.org/privacy-policy/">Privacy Policy</a>
    </div>
  );
}
